import React from "react";
import { Page, Navbar, Block } from "framework7-react";
const Page404 = () => {
  return (
    <Page className="bg-white">
      <div className="container container-table ">
        <div className="row vertical-center-row col-md-12 col-md-offset-12">
          <div className="text-center">
            <Navbar title="Not found" backLink="Back" />
            <Block strong>
              <p>Sorry</p>
              <p>Requested content not found.</p>
            </Block>
          </div>
       </div>
      </div>
    </Page>
  );
};

export default Page404;